/**
 * 本地后端地址
 */
// export const BACKEND_HOST_LOCAL = "http://127.0.0.1:4523/m1/7882287-7632172-default"; 
export const BACKEND_HOST_LOCAL = "http://192.168.103.60:8080"; 

//http://127.0.0.1:4523/m1/7882287-7632172-default  http://localhost:8101/api

/**
 * 线上后端地址
 */
export const BACKEND_HOST_PROD = "https://lyxusheng.cn";
